import * as React from 'react';

const Close12: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg width='12' height='12' viewBox='0 0 12 12' fill='none' aria-hidden='true'>
		<path d='M2 10L10 2M2 2L10 10' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
	</svg>
);

export { Close12 };
